import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import request from 'request';
import isDateNotInFuture from 'utils/is-data-is-not-in-future';
import mainTranscript from 'utils/transcript';
import { useClientContext } from '..';
import styles from '../application-group.module.scss';
import Input from '../components/input';
import transcript from '../utils/transcript';

let timeout: NodeJS.Timeout;
const Scoring = () => {
	const { group, application, stop_factors, setGroup } = useClientContext();
	const { id, clientId } = useParams();

	const [form, setForm] = React.useState({
		id: '',
		dependants: '',
		family_status: '',
		age: '',
		gender: '',
		prior_loans: '',
		phone_os: '',
		transport: '',
		residence_type: '',
		employment_level: '',
		employment_status: '',
		work_experience: '',
		transport_manufacturing_year: '',
		nationality: '',
		address: '',
		repeated_client: '',
		postpone_payments: '',
		project_net_monthly_income: '',
		additional_income: '',
		monthly_payment_for_active_loans: '',
		active_loan_with_same_family_id: '',
		dual_loans: '',
		max_days_late_payments: '',
		client_status_gurantor: '',
		family_members_delinquent: '',
		current_application_with_same_family_id: '',
		client_has_early_settlement_loan: '',
		date_of_early_settlements_loan: '',
		longest_payment_delay_by_guarantor: '',
		number_of_active_upcoming_payments: '',
	});

	useEffect(() => {
		setForm((prev) =>
			String(application.id) === prev.id
				? prev
				: {
						id: String(application.id),
						dependants:
							application.scoring_log?.dependants !== null
								? String(application.scoring_log?.dependants)
								: '',
						family_status:
							application.scoring_log?.family_status !== null
								? transcript.family_status(application.scoring_log?.family_status ?? '')!
								: '',

						age: application.scoring_log?.age !== null ? String(application.scoring_log?.age) : '',
						gender:
							application.scoring_log?.gender !== null
								? String(application.scoring_log?.gender)
								: '',
						prior_loans: application?.prior_loans !== null ? String(application?.prior_loans) : '',
						phone_os: application.scoring_log?.phone_os ?? '',
						transport: application.scoring_log?.transport ?? '',
						residence_type: application.scoring_log?.residence_type ?? '',
						employment_level: application.scoring_log?.employment_level ?? '',
						employment_status: application.scoring_log?.employment_status ?? '',
						work_experience:
							application.scoring_log?.work_experience !== null
								? String(application.scoring_log?.work_experience)
								: '',
						transport_manufacturing_year:
							application.scoring_log?.transport_manufacturing_year !== null
								? String(application.scoring_log?.transport_manufacturing_year)
								: '',
						nationality: application.scoring_log?.nationality ?? '',
						address: application.scoring_log?.address ?? '',
						repeated_client:
							application?.repeated_client !== null
								? String(transcript.repeated_client(application?.repeated_client ?? ''))
								: '',
						postpone_payments:
							application.scoring_log?.postpone_payments !== null
								? String(application.scoring_log?.postpone_payments)
								: '',
						project_net_monthly_income:
							application.scoring_log?.project_net_monthly_income !== null
								? String(application.scoring_log?.project_net_monthly_income)
								: '',
						additional_income:
							application.scoring_log?.additional_income !== null
								? String(application.scoring_log?.additional_income)
								: '',
						monthly_payment_for_active_loans:
							application.scoring_log?.monthly_payment_for_active_loans !== null
								? String(application.scoring_log?.monthly_payment_for_active_loans)
								: '',
						dual_loans:
							application.scoring_log?.dual_loans === null
								? ''
								: application.scoring_log?.dual_loans === false
								? 'No'
								: 'Yes',
						max_days_late_payments:
							application.scoring_log?.max_days_late_payments !== null
								? String(application.scoring_log?.max_days_late_payments)
								: '',
						client_status_gurantor:
							application.scoring_log?.client_status_gurantor === null
								? ''
								: application.scoring_log?.client_status_gurantor === false
								? 'No'
								: 'Yes',
						active_loan_with_same_family_id:
							application.scoring_log?.active_loan_with_same_family_id === null
								? ''
								: (application.scoring_log?.active_loan_with_same_family_id as 'Yes' | 'No'),
						family_members_delinquent:
							application.scoring_log?.family_members_delinquent === null
								? ''
								: application.scoring_log?.family_members_delinquent === false
								? 'No'
								: 'Yes',
						current_application_with_same_family_id:
							application.scoring_log?.current_application_with_same_family_id === null
								? ''
								: application.scoring_log?.current_application_with_same_family_id === 'No'
								? 'No'
								: 'Yes',
						client_has_early_settlement_loan:
							application.scoring_log?.client_has_early_settlement_loan ?? '',
						date_of_early_settlements_loan: application.scoring_log?.date_of_early_settlements_loan
							? application.scoring_log?.date_of_early_settlements_loan
									.split('-')
									.reverse()
									.join('/')
							: '',
						longest_payment_delay_by_guarantor:
							application.scoring_log?.longest_payment_delay_by_guarantor !== null
								? String(application.scoring_log?.longest_payment_delay_by_guarantor)
								: '',
						number_of_active_upcoming_payments:
							application.scoring_log?.number_of_active_upcoming_payments !== null
								? String(application.scoring_log?.number_of_active_upcoming_payments)
								: '0',
				  }
		);
	}, [application]);

	const handleChangeForm = (key: keyof typeof form, value: string) => {
		clearTimeout(timeout);
		const newForm = { ...form };
		if (key === 'employment_status' && (value === 'Unemployed' || value === 'None')) {
			newForm['work_experience'] = '0';
			newForm['employment_level'] = 'None';
		}
		if (key === 'repeated_client' && value === 'New') {
			newForm['number_of_active_upcoming_payments'] = '0';
			newForm['postpone_payments'] = '0';
		}
		if (key === 'client_has_early_settlement_loan' && value === 'No') {
			newForm['date_of_early_settlements_loan'] = '';
		}
		newForm[key] = value;
		setForm(newForm);
		timeout = setTimeout(() => {
			request
				.put(`/applications/group/${id}/${clientId}`, {
					amount: application.amount,
					duration: application.duration,
					interest_rate: application.interest_rate * 100,
					number_of_payments: application.number_of_payments,
					loan_duration_of_current_loan: application.loan_duration_of_current_loan,
					prior_loans: newForm.prior_loans !== '' ? Number(newForm.prior_loans) : null,
					active_loans_credit_cards: application?.active_loans_credit_cards,
					repeated_client: transcript.repeated_client(newForm.repeated_client),
					scoring_data: {
						dependants: newForm.dependants !== '' ? Number(newForm.dependants) : null,
						family_status: transcript.family_status(newForm.family_status),
						gender: newForm.gender === '' ? null : newForm.gender,
						age: newForm.age !== '' ? Number(newForm.age) : null,
						city: application.scoring_log?.city,
					},
					collected_data: {
						branch: application.scoring_log?.branch,
						phone_os: newForm.phone_os !== '' ? newForm.phone_os : null,
						transport: newForm.transport !== '' ? newForm.transport : null,
						residence_type: newForm.residence_type !== '' ? newForm.residence_type : null,
						employment_level: newForm.employment_level !== '' ? newForm.employment_level : null,
						employment_status: newForm.employment_status !== '' ? newForm.employment_status : null,
						work_experience:
							newForm.work_experience !== '' ? Number(newForm.work_experience) : null,
						transport_manufacturing_year:
							newForm.transport_manufacturing_year !== ''
								? Number(newForm.transport_manufacturing_year)
								: null,
						nationality: newForm.nationality !== '' ? newForm.nationality : null,
						address: newForm.address !== '' ? newForm.address : null,
						client_has_early_settlement_loan:
							newForm?.client_has_early_settlement_loan !== ''
								? newForm?.client_has_early_settlement_loan
								: null,
						postpone_payments:
							newForm.postpone_payments !== '' ? Number(newForm.postpone_payments) : null,
						project_net_monthly_income:
							newForm.project_net_monthly_income !== ''
								? Number(newForm.project_net_monthly_income)
								: null,
						additional_income:
							newForm.additional_income !== '' ? Number(newForm.additional_income) : null,
						monthly_payment_for_active_loans:
							newForm.monthly_payment_for_active_loans !== ''
								? Number(newForm.monthly_payment_for_active_loans)
								: null,
						guarantor_income: null,
						guarantor_additional_income: null,
						guarantor_total_monthly_payments: null,
					},
					stop_factors: {
						group_loan: true,
						loan_purpose: application.scoring_log?.loan_purpose,
						dual_loans: transcript.dual_loans(newForm.dual_loans),
						max_days_late_payments:
							newForm.max_days_late_payments !== '' ? Number(newForm.max_days_late_payments) : null,
						client_status_gurantor: transcript.client_status_gurantor(
							newForm.client_status_gurantor
						),
						family_members_delinquent: transcript.family_members_delinquent(
							newForm.family_members_delinquent
						),
						active_loan_with_same_family_id: transcript.active_loan_with_same_family_id(
							newForm.active_loan_with_same_family_id
						),
						guarantor_age: null,
						guarantor_has_active_loan: null,
						guarantor_for_another_loan: null,
						current_application_with_same_family_id:
							application.scoring_log?.current_application_with_same_family_id,
						date_of_early_settlements_loan:
							newForm.client_has_early_settlement_loan !== 'No' &&
							newForm.date_of_early_settlements_loan.length === 10
								? newForm.date_of_early_settlements_loan.split('/').reverse().join('-')
								: null,
						longest_payment_delay_by_guarantor:
							newForm.longest_payment_delay_by_guarantor !== ''
								? Number(newForm.longest_payment_delay_by_guarantor)
								: null,
						number_of_active_upcoming_payments:
							newForm.number_of_active_upcoming_payments !== ''
								? Number(newForm.number_of_active_upcoming_payments)
								: 0,
					},
				})
				.then(() => {
					request
						.get(`/applications/group/${id}`)
						.then((res) => res.data)
						.then((res) => {
							setGroup(res);
						});
				});
		}, 1000);
	};

	if (group.scoring_approved || group.stop_factors_approved)
		return (
			<div className={styles.scoring_result}>
				<div className={styles.section}>
					<div className={styles.title}>Credit data</div>
					<div className={styles.item}>
						<div className={styles.key}>Amount</div>
						<div className={styles.value}>{application.amount} JOD</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Duration</div>
						<div className={styles.value}>{application.duration} mon.</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Interest rate (annual)</div>
						<div className={styles.value}>{(application.interest_rate * 100).toFixed(2)} %</div>
					</div>

					<div className={styles.item}>
						<div className={styles.key}>Repeated client?</div>
						<div className={styles.value}>
							{transcript.repeated_client(application.repeated_client ?? '')}
						</div>
					</div>

					{application.loan_duration_of_current_loan !== null && (
						<div className={styles.item}>
							<div className={styles.key}>Loan duration of current loan</div>
							<div className={styles.value}>{application.loan_duration_of_current_loan} mon.</div>
						</div>
					)}

					<div className={styles.item}>
						<div className={styles.key}>Prior loans</div>
						<div className={styles.value}>{application.prior_loans}</div>
					</div>

					<div className={styles.item}>
						<div className={styles.key}>Number of payments</div>
						<div className={styles.value}>{application.number_of_payments}</div>
					</div>

					<div className={styles.item}>
						<div className={styles.key}>Threshold</div>
						<div className={styles.value}>{Number(application.scoring_log?.threshold) * 100} %</div>
					</div>
				</div>
				<div className={styles.section}>
					<div className={styles.title}>Client data</div>
					<div className={styles.item}>
						<div className={styles.key}>Gender</div>
						<div className={styles.value}>
							{transcript.gender(application.scoring_log?.gender ?? '')}
						</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Family status</div>
						<div className={styles.value}>
							{transcript.family_status(application.scoring_log?.family_status ?? '')}
						</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Dependants</div>
						<div className={styles.value}>{application.scoring_log?.dependants}</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Client residence</div>
						<div className={styles.value}>
							{mainTranscript.city.getValueFromKey(application.scoring_log?.city ?? '')}
						</div>
					</div>
				</div>
				<div className={styles.section}>
					<div className={styles.title}>Alternative data</div>
					<div className={styles.item}>
						<div className={styles.key}>Transport manufacturing year</div>
						<div className={styles.value}>
							{application.scoring_log?.transport_manufacturing_year}
						</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Transport</div>
						<div className={styles.value}>{application.scoring_log?.transport}</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Employment status</div>
						<div className={styles.value}>{application.scoring_log?.employment_status}</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Employment level</div>
						<div className={styles.value}>{application.scoring_log?.employment_level}</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Residence type</div>
						<div className={styles.value}>{application.scoring_log?.residence_type}</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Work experience</div>
						<div className={styles.value}>{application.scoring_log?.work_experience}</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Phone OS</div>
						<div className={styles.value}>{application.scoring_log?.phone_os}</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Branch</div>
						<div className={styles.value}>
							{mainTranscript.branch.getValueFromKey(application.scoring_log?.branch ?? '')}
						</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Nationality</div>
						<div className={styles.value}>{application.scoring_log?.nationality}</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Address</div>
						<div className={styles.value}>{application.scoring_log?.address}</div>
					</div>

					<div className={styles.item}>
						<div className={styles.key}>Postponed payments/installments</div>
						<div className={styles.value}>{application.scoring_log?.postpone_payments}</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Project net monthly income</div>
						<div className={styles.value}>
							{application.scoring_log?.project_net_monthly_income?.toFixed(2)} JOD
						</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Additional income</div>
						<div className={styles.value}>
							{application.scoring_log?.additional_income?.toFixed(2)} JOD
						</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Client monthly payment for active loans (non-AMC)</div>
						<div className={styles.value}>
							{application.scoring_log?.monthly_payment_for_active_loans?.toFixed(2)} JOD
						</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Monthly payment</div>
						<div className={styles.value}>
							{application.scoring_log?.monthly_payment?.toFixed(2)} JOD
						</div>
					</div>
					<div className={styles.item}>
						<div className={styles.key}>Client has early settlement loan</div>
						<div className={styles.value}>
							{application.scoring_log?.client_has_early_settlement_loan}
						</div>
					</div>
				</div>
				<div className={styles.section}>
					<div className={styles.title}>Manual stop factors</div>
					<div className={styles.row}>
						<div className={styles.col}>Prohibited loan purpose</div>
						<div className={styles.col}>{application.scoring_log?.loan_purpose ? 'Yes' : 'No'}</div>
						<div
							className={classNames(
								styles.col,
								stop_factors?.loan_purpose === 'approved'
									? styles.green
									: stop_factors?.loan_purpose === 'rejected'
									? styles.red
									: styles.yellow
							)}
						>
							{stop_factors?.loan_purpose === 'approved'
								? 'Approved'
								: stop_factors?.loan_purpose === 'rejected'
								? 'Rejected'
								: 'Review'}
						</div>
					</div>
					<div className={styles.row}>
						<div className={styles.col}>Age</div>
						<div className={styles.col}>{application.scoring_log?.age} y/o</div>
						<div
							className={classNames(
								styles.col,
								stop_factors?.age === 'approved'
									? styles.green
									: stop_factors?.age === 'rejected'
									? styles.red
									: styles.yellow
							)}
						>
							{stop_factors?.age === 'approved'
								? 'Approved'
								: stop_factors?.age === 'rejected'
								? 'Rejected'
								: 'Review'}
						</div>
					</div>
					<div className={styles.row}>
						<div className={styles.col}>Dual loans</div>
						<div className={styles.col}>{application.scoring_log?.dual_loans ? 'Yes' : 'No'}</div>
						<div
							className={classNames(
								styles.col,
								stop_factors?.dual_loans === 'approved'
									? styles.green
									: stop_factors?.dual_loans === 'rejected'
									? styles.red
									: styles.yellow
							)}
						>
							{stop_factors?.dual_loans === 'approved'
								? 'Approved'
								: stop_factors?.dual_loans === 'rejected'
								? 'Rejected'
								: 'Review'}
						</div>
					</div>
					<div className={styles.row}>
						<div className={styles.col}>Longest payment delay by client (in days)</div>
						<div className={styles.col}>{application.scoring_log?.max_days_late_payments}</div>
						<div
							className={classNames(
								styles.col,
								stop_factors?.max_days_late_payments === 'approved'
									? styles.green
									: stop_factors?.max_days_late_payments === 'rejected'
									? styles.red
									: styles.yellow
							)}
						>
							{stop_factors?.max_days_late_payments === 'approved'
								? 'Approved'
								: stop_factors?.max_days_late_payments === 'rejected'
								? 'Rejected'
								: 'Review'}
						</div>
					</div>
					<div className={styles.row}>
						<div className={styles.col}>Client is already a guarantor for another active loan?</div>
						<div className={styles.col}>
							{application.scoring_log?.client_status_gurantor ? 'Yes' : 'No'}
						</div>
						<div
							className={classNames(
								styles.col,
								stop_factors?.client_status_gurantor === 'approved'
									? styles.green
									: stop_factors?.client_status_gurantor === 'rejected'
									? styles.red
									: styles.yellow
							)}
						>
							{stop_factors?.client_status_gurantor === 'approved'
								? 'Approved'
								: stop_factors?.client_status_gurantor === 'rejected'
								? 'Rejected'
								: 'Review'}
						</div>
					</div>
					<div className={styles.row}>
						<div className={styles.col}>Active loan with same family ID</div>
						<div className={styles.col}>
							{application.scoring_log?.active_loan_with_same_family_id}
						</div>
						<div
							className={classNames(
								styles.col,
								stop_factors?.active_loan_with_same_family_id === 'approved'
									? styles.green
									: stop_factors?.active_loan_with_same_family_id === 'rejected'
									? styles.red
									: styles.yellow
							)}
						>
							{stop_factors?.active_loan_with_same_family_id === 'approved'
								? 'Approved'
								: stop_factors?.active_loan_with_same_family_id === 'rejected'
								? 'Rejected'
								: 'Review'}
						</div>
					</div>
					<div className={styles.row}>
						<div className={styles.col}>Current application with same family ID</div>
						<div className={styles.col}>
							{application.scoring_log?.current_application_with_same_family_id}
						</div>
						<div
							className={classNames(
								styles.col,
								stop_factors?.current_application_with_same_family_id === 'approved'
									? styles.green
									: stop_factors?.current_application_with_same_family_id === 'rejected'
									? styles.red
									: styles.yellow
							)}
						>
							{stop_factors?.current_application_with_same_family_id === 'approved'
								? 'Approved'
								: stop_factors?.current_application_with_same_family_id === 'rejected'
								? 'Rejected'
								: 'Review'}
						</div>
					</div>
					<div className={styles.row}>
						<div className={styles.col}>Family members delinquent (in the same house)</div>
						<div className={styles.col}>
							{application.scoring_log?.family_members_delinquent ? 'Yes' : 'No'}
						</div>
						<div
							className={classNames(
								styles.col,
								stop_factors?.family_members_delinquent === 'approved'
									? styles.green
									: stop_factors?.family_members_delinquent === 'rejected'
									? styles.red
									: styles.yellow
							)}
						>
							{stop_factors?.family_members_delinquent === 'approved'
								? 'Approved'
								: stop_factors?.family_members_delinquent === 'rejected'
								? 'Rejected'
								: 'Review'}
						</div>
					</div>
					<div className={styles.row}>
						<div className={styles.col}>Additional income</div>
						<div className={styles.col}>
							{application.scoring_log?.additional_income !== null
								? `${application.scoring_log?.additional_income} JOD`
								: 'N/A'}
						</div>
						<div
							className={classNames(
								styles.col,
								stop_factors?.additional_income === 'approved'
									? styles.green
									: stop_factors?.additional_income === 'rejected'
									? styles.red
									: styles.yellow
							)}
						>
							{stop_factors?.additional_income === 'approved'
								? 'Approved'
								: stop_factors?.additional_income === 'rejected'
								? 'Rejected'
								: 'Review'}
						</div>
					</div>
					<div className={styles.row}>
						<div className={styles.col}>Client DBR</div>
						<div className={styles.col}>
							{stop_factors?.client_dbr === null
								? 'Zero income'
								: application.scoring_log?.client_dbr !== null
								? `${(Number(application.scoring_log?.client_dbr) * 100)?.toFixed(2)}%`
								: 'N/A'}
						</div>
						<div
							className={classNames(
								styles.col,
								stop_factors?.client_dbr === 'approved'
									? styles.green
									: stop_factors?.client_dbr === 'rejected' || stop_factors?.client_dbr === null
									? styles.red
									: styles.yellow
							)}
						>
							{stop_factors?.client_dbr === 'approved'
								? 'Approved'
								: stop_factors?.client_dbr === 'rejected' || stop_factors?.client_dbr === null
								? 'Rejected'
								: 'Review'}
						</div>
					</div>
					<div className={styles.row}>
						<div className={styles.col}>Date of early settlement loan</div>
						<div className={styles.col}>
							{application.scoring_log?.date_of_early_settlements_loan}
						</div>
						<div
							className={classNames(
								styles.col,
								stop_factors?.date_of_early_settlements_loan === 'approved'
									? styles.green
									: stop_factors?.date_of_early_settlements_loan === 'rejected'
									? styles.red
									: styles.yellow
							)}
						>
							{stop_factors?.date_of_early_settlements_loan === 'approved'
								? 'Approved'
								: stop_factors?.date_of_early_settlements_loan === 'rejected'
								? 'Rejected'
								: 'Review'}
						</div>
					</div>
					<div className={styles.row}>
						<div className={styles.col}>Nationality</div>
						<div className={styles.col}>{application.scoring_log?.nationality}</div>
						<div
							className={classNames(
								styles.col,
								stop_factors?.nationality === 'approved'
									? styles.green
									: stop_factors?.nationality === 'rejected'
									? styles.red
									: styles.yellow
							)}
						>
							{stop_factors?.nationality === 'approved'
								? 'Approved'
								: stop_factors?.nationality === 'rejected'
								? 'Rejected'
								: 'Review'}
						</div>
					</div>
				</div>
			</div>
		);

	return (
		<div className={styles.scoring}>
			<div className={styles.section}>
				<div className={styles.title}>Client data</div>
				<Input
					title="Age"
					value={form.age}
					step={1}
					max={80}
					min={18}
					type="integer"
					onInput={(value) => handleChangeForm('age', value)}
				/>
				<Input
					title="Gender"
					id="gender"
					value={form.gender}
					type="select"
					options={['female', 'male']}
					onSelect={(option) => handleChangeForm('gender', option)}
				/>
				<Input
					title="Family status"
					id="family_status"
					value={form.family_status}
					type="select"
					options={['Divorced', 'Married', 'Single', 'Widowed']}
					onSelect={(option) => handleChangeForm('family_status', option)}
				/>
				<Input
					title="Dependants"
					value={form.dependants}
					step={1}
					min={0}
					max={97}
					type="integer"
					onInput={(value) => handleChangeForm('dependants', value)}
				/>
				<Input
					title="Nationality"
					id="nationality"
					value={form.nationality}
					type="select"
					hasFilterText
					options={['Jordan', 'Gaza']}
					onSelect={(option) => handleChangeForm('nationality', option)}
				/>
				<Input
					title="Address"
					value={form.address}
					type="string"
					onInput={(value) => handleChangeForm('address', value)}
				/>
				<Input
					title="Postponed payments/installments"
					value={form.postpone_payments}
					step={1}
					type="float"
					min={0}
					max={1000000}
					disabled={form.repeated_client === 'New'}
					onInput={(value) => handleChangeForm('postpone_payments', value)}
				/>
				<Input
					title="Dual loans"
					id="dual_loans"
					value={form.dual_loans}
					type="select"
					options={['Yes', 'No']}
					onSelect={(option) => handleChangeForm('dual_loans', option)}
				/>
				<Input
					title="Longest payment delay by client (in days)"
					value={form.max_days_late_payments}
					step={1}
					min={0}
					max={1000000}
					type="integer"
					onInput={(value) => handleChangeForm('max_days_late_payments', value)}
				/>
				<Input
					title="Client is already a guarantor for another active loan?"
					id="client_status_gurantor"
					value={form.client_status_gurantor}
					type="select"
					options={['Yes', 'No']}
					onSelect={(option) => handleChangeForm('client_status_gurantor', option)}
				/>
				<Input
					title="Active loan with same family ID"
					id="active_loan_with_same_family_id"
					value={form.active_loan_with_same_family_id}
					type="select"
					options={['Yes', 'No']}
					onSelect={(option) => handleChangeForm('active_loan_with_same_family_id', option)}
				/>
				<Input
					title="Family members delinquent (in the same house)"
					id="family_members_delinquent"
					value={form.family_members_delinquent}
					type="select"
					options={['Yes', 'No']}
					onSelect={(option) => handleChangeForm('family_members_delinquent', option)}
				/>
				<Input
					title="Project net monthly income"
					value={form.project_net_monthly_income}
					step={1}
					min={0}
					max={1000000}
					type="float"
					onInput={(value) => handleChangeForm('project_net_monthly_income', value)}
				/>
				<Input
					title="Additional income"
					value={form.additional_income}
					step={1}
					min={0}
					max={1000000}
					type="float"
					onInput={(value) => handleChangeForm('additional_income', value)}
				/>
				<Input
					title="Client monthly payment for active loans (non-AMC)"
					value={form.monthly_payment_for_active_loans}
					step={1}
					min={0}
					max={1000000}
					type="float"
					onInput={(value) => handleChangeForm('monthly_payment_for_active_loans', value)}
				/>
				<Input
					title="Client has early settlement loan"
					value={form.client_has_early_settlement_loan}
					type="select"
					className={styles.fitHeight}
					onSelect={(option) => handleChangeForm('client_has_early_settlement_loan', option)}
					options={['Yes', 'No']}
				/>
				<div className={styles.input}>
					<Input
						title="Date of early settlement loan"
						value={
							form.client_has_early_settlement_loan === 'No'
								? ''
								: form.date_of_early_settlements_loan &&
								  new Date(form.date_of_early_settlements_loan.split('/').reverse().join('/'))
						}
						type="date"
						maxLength={10}
						disabled={form.client_has_early_settlement_loan === 'No'}
						onSetDate={(value) => {
							handleChangeForm(
								'date_of_early_settlements_loan',
								new Date(value).toLocaleDateString('ru-RU').replaceAll('.', '/')
							);
						}}
					/>
					{form.client_has_early_settlement_loan !== 'No' &&
						form.date_of_early_settlements_loan !== '' &&
						form.date_of_early_settlements_loan.length === 10 &&
						isDateNotInFuture(form.date_of_early_settlements_loan) && (
							<div className={styles.error}>
								{isDateNotInFuture(form.date_of_early_settlements_loan)}
							</div>
						)}
				</div>
			</div>
			<div className={styles.section}>
				<div className={styles.title}>Alternative data</div>
				<Input
					title="Residence type"
					id="residenceType"
					value={form.residence_type}
					type="select"
					options={['Rent', 'Ownership', 'On loan', 'Other', 'None']}
					onSelect={(option) => handleChangeForm('residence_type', option)}
				/>
				<Input
					title="Transport"
					id="transport"
					value={form.transport}
					type="select"
					options={['Rent', 'Ownership', 'On loan', 'Other', 'None']}
					onSelect={(option) => handleChangeForm('transport', option)}
				/>
				<Input
					title="Transport manufacturing year"
					value={form.transport_manufacturing_year}
					step={1}
					min={1900}
					max={new Date().getFullYear() + 2}
					type="integer"
					onInput={(value) => handleChangeForm('transport_manufacturing_year', value)}
				/>
				<Input
					title="Employment status"
					id="employmentStatus"
					value={form.employment_status}
					type="select"
					options={['Employed', 'Unemployed', 'Other', 'None']}
					onSelect={(option) => handleChangeForm('employment_status', option)}
				/>
				<Input
					title="Employment level"
					id="employmentLevel"
					value={form.employment_level}
					type="select"
					disabled={form.employment_status === 'None' || form.employment_status === 'Unemployed'}
					options={[
						'Government agency',
						'Public organization',
						'Private company',
						'Individual entrepreneur',
						'Other',
						'None',
					]}
					onSelect={(option) => handleChangeForm('employment_level', option)}
				/>
				<Input
					title="Work experience"
					value={form.work_experience}
					step={1}
					min={0}
					max={97}
					type="integer"
					disabled={form.employment_status === 'None' || form.employment_status === 'Unemployed'}
					onInput={(value) => handleChangeForm('work_experience', value)}
					unit="mon."
				/>
				<Input
					title="Phone OS"
					id="phoneOS"
					value={form.phone_os}
					type="select"
					options={['iOS', 'Android', 'Other', 'None']}
					onSelect={(option) => handleChangeForm('phone_os', option)}
				/>
			</div>
		</div>
	);
};

export default Scoring;
